import { CheckPersonRulesMatrixModel, GetPersonModel, PersonModel } from '@bayclubs/court-booking-employee-api';
import { BcStateContext, BcStateListContext } from '@bayclubs/state';
import { ChangePlayerInputModel } from '../models/change-player-input.model';


export const PLAYERS_FEATURE_KEY = 'players';

export interface PlayersStateModel {
    player: BcStateContext<GetPersonModel>;
    players: BcStateListContext<PersonModel>;
    selectedPlayer: PersonModel;
    selectedPlayerRulesMatrix: CheckPersonRulesMatrixModel;
    playerInput: ChangePlayerInputModel;
}
